import React, { lazy } from 'react'
import { SuspendDocument } from '../SuspendFolio/SuspendDocument'

const NonGuestFolioList = lazy(() =>
  import('./NonGuestFolioList').then(module => ({
    default: module.NonGuestFolioList,
  }))
)
const NonGuestFolioForm = lazy(() =>
  import('./NonGuestFolioForm').then(module => ({
    default: module.NonGuestFolioForm,
  }))
)
const NonGuestFolio = lazy(() =>
  import('./NonGuestFolio').then(module => ({
    default: module.NonGuestFolio,
  }))
)
const SuspendReceipt =lazy(() => 
  import('../SuspendFolio/SuspendReceiptDocument').then(module => ({
    default: module.SuspendReceiptDocument,
  }))
)

export const TypesRoute = {
  Refund: 'REFUND VOUCHER',
  AdvancePayment: 'ADVANCE PAYMENT',
  Folio: 'FOLIO',
  Receipt: 'RECEIPT',
  RefundFolio: 'REFUND',
}

export const nonGuestFolioUrl = '/'
export const NonGuestFolioRoutes = [
  {
    props: { exact: true, path: '/frontdesk/nonguestfoliolist' },
    component: <NonGuestFolioList />,
  },
  {
    props: { exact: true, path: '/frontdesk/nonguestfoliolist/add' },
    component: <NonGuestFolioForm mode={'Add'} />,
  },
  {
    props: { exact: true, path: '/frontdesk/nonguestfoliolist/edit' },
    component: <NonGuestFolioForm mode={'Edit'} />,
  },
  {
    props: { exact: true, path: '/frontdesk/nonguestfoliolist/folio' },
    component: <NonGuestFolio />,
  },
  {
    props: { exact: true, path: '/frontdesk/nonguestfoliolist/folio/redirect/:status' },
    component: <NonGuestFolio />,
  },
  {
    props: { exact: true, path: '/frontdesk/nonguestfoliolist/folio/print' },
    component: <SuspendDocument mode={''} type="NoGuest" />,
  },
  {
    props: { exact: true, path: '/frontdesk/nonguestfoliolist/folio/print/receipt' },
    component: <SuspendReceipt />,
  },
  {
    props: { exact: true, path: '/frontdesk/nonguestfoliolist/folio/print/refund' },
    component: <SuspendReceipt type={TypesRoute.Refund}/>,
  },
  {
    props: { exact: true, path: '/frontdesk/nonguestfoliolist/folio/close/print' },
    component: <SuspendDocument mode={''} type="NoGuest" close={true}/>,
  }
]
